export default "__VITE_ASSET__BiSZ6Ade__"